// Image assets exports
// Import and export your images here for easier importing

import TrustJetPlaneImage from './backgrounds/bgplaceholdernew.jpg';

// Logos
// export { default as TrustJetLogo } from './logos/trustjet-logo.png';
// export { default as TrustJetLogoWhite } from './logos/trustjet-logo-white.png';

// Backgrounds
// export { default as AirplaneBackground } from './backgrounds/airplane-sky.jpg';
// export { default as LoginBackground } from './backgrounds/login-bg.jpg';

// Icons
// export { default as PlaneIcon } from './icons/plane.svg';

// Avatars
// export { default as DefaultAvatar } from './avatars/default-avatar.png';

// Usage example:
// import { TrustJetLogo, AirplaneBackground } from '../assets/images';

export { default as TrustJetLogoWhite } from './logos/logo_white.svg';
export { default as TrustJetLogoBlack } from './logos/logo_black.svg';
export { default as TrustJetLogoWhiteSlunt } from './logos/whitelogoslunt.png';
export { default as TrustJetBackground } from './backgrounds/bgsky2.jpg';
export { default as TrustJetLogoColored } from './logos/logoblack.png';
export const TrustJetPlane = TrustJetPlaneImage;
export { default as TrustJetLogoV2 } from './logos/logov2.png';
export { default as TrustJetBrandLogo } from './logos/brand_logos.png';
export { default as EmptyState } from './logos/empty_state.svg';
export { default as EmptyState2 } from './logos/empty_state_2.svg';
export { default as EmptyState2Gray } from './logos/empty_state_2gray.svg';
export { default as TrustJetEmailBackground } from './backgrounds/bgemail.jpg';
export { default as TrustJetPassengerBackground } from './backgrounds/bgpassengers.jpg';

// Aircraft images - dynamically imported by filename using webpack's require.context
// Usage: const image = aircraftImages['BD-700-1A10'] or getAircraftImage('BD-700-1A10')
const aircraftContext = require.context('./aircraft', false, /\.(jpg|png)$/);

export const aircraftImages = Object.fromEntries(
  aircraftContext.keys().map((path) => {
    // Extract filename without extension: './BD-700-1A10.jpg' -> 'BD-700-1A10'
    const filename = path.replace('./', '').replace(/\.(jpg|png)$/, '');
    return [filename, aircraftContext(path)];
  })
);

// Map model name -> original filename with extension (e.g. 'BD-700-1A10' -> 'BD-700-1A10.jpg')
const aircraftFilenames = Object.fromEntries(
  aircraftContext.keys().map((path) => {
    const fullFilename = path.replace('./', '');
    const modelName = fullFilename.replace(/\.(jpg|png)$/, '');
    return [modelName, fullFilename];
  })
);

// Aircraft carousel images - loads all images from subdirectories
// e.g. ./aircraft/BD-100-1A10/*.jpg -> aircraftCarouselImages['BD-100-1A10'] = [img1, img2, ...]
const aircraftDirContext = require.context('./aircraft', true, /\/[^/]+\/[^/]+\.(jpg|png)$/);

// Keep both the webpack-resolved URLs (for in-app rendering) and the raw
// "dirName/filename.jpg" paths — the latter map 1:1 onto public/images/aircraft/
// which is a stable, absolute URL that works in emails.
export const aircraftCarouselImages = {};
const aircraftCarouselPublicPaths = {};
aircraftDirContext.keys().forEach((path) => {
  // path format: './BD-100-1A10/image.jpg'
  const rel = path.replace('./', '');
  const dirName = rel.split('/')[0];
  if (!aircraftCarouselImages[dirName]) {
    aircraftCarouselImages[dirName] = [];
    aircraftCarouselPublicPaths[dirName] = [];
  }
  aircraftCarouselImages[dirName].push(aircraftDirContext(path));
  aircraftCarouselPublicPaths[dirName].push(rel);
});

// Helper function to get aircraft image by model name
// If model is a directory, returns the first image from that directory
export const getAircraftImage = (modelName) => {
  const filename = aircraftFilenames[modelName];
  if (filename) return `${window.location.origin}/images/aircraft/${filename}`;
  // Prefer the stable public/images/aircraft/{dir}/{file} URL (hash-free,
  // survives redeploys, resolvable in emails) over the webpack-resolved URL.
  const publicPaths = aircraftCarouselPublicPaths[modelName];
  if (publicPaths && publicPaths.length > 0) {
    return `${window.location.origin}/images/aircraft/${publicPaths[0]}`;
  }
  return `${window.location.origin}/images/bgplaceholdernew.jpg`;
};

// Returns every bundled image for a model as a stable public URL list.
// Used by carousels / trip-sheet media rows / quote gallery when every DB
// URL fails — instead of one duplicated fallback card, show the full set
// (e.g. CE-550-550 has 3 → 3-slide carousel). Empty when no bundle exists.
export const getAircraftBundledCarouselUrls = (modelName) => {
  if (!modelName) return [];
  const publicPaths = aircraftCarouselPublicPaths[modelName];
  if (publicPaths && publicPaths.length > 0) {
    return publicPaths.map(
      (p) => `${window.location.origin}/images/aircraft/${p}`,
    );
  }
  const single = aircraftFilenames[modelName];
  if (single) return [`${window.location.origin}/images/aircraft/${single}`];
  return [];
};

// Helper function to get all carousel images for an aircraft model
// If model is a directory, returns all images; if a single file, wraps it in an array
export const getAircraftCarouselImages = (modelName) => {
  const dirImages = aircraftCarouselImages[modelName];
  if (dirImages && dirImages.length > 0) return dirImages;
  const single = aircraftImages[modelName];
  return single ? [single] : [TrustJetPlaneImage];
};

